import axios from 'axios';
import Vue from 'vue';
import {Video} from '../../../shared/entities/Video';
import {Series} from '../../../shared/entities/Series';
import Category from '../../../shared/entities/Category';
import BatchRequest from '../../../shared/util/BatchRequest';
import Soundtrack from '../../../shared/entities/Soundtrack';

const options = {
	baseURL: 'https://old.rwbybrasil.com/do/',
	withCredentials: true
};

export const oldApi = axios.create(options);

/**
 * @param {AxiosRequestConfig} config
 */
oldApi.getUrl = function(config) {
	return options.baseURL + this.getUri(config)
};
oldApi.getDynamicFolderUrl = function(config) {
	return options.baseURL.replace('/do/', '/dynamic/') + this.getUri(config)
};


oldApi.Video = {
	async getHighlight() {
		let {data} = await oldApi.get('Video.Highlight');

		return data.map(x => new Video(x));
	},

	async get(id) {
		let {data} = await oldApi.get('Video.Get', {
			params: {
				id
			}
		});

		return data ? new Video(data) : null;
	},

	async listByCategory(categoryId) {
		let {data} = await oldApi.get('Video.ListBy', {
			params: {
				categoryId
			}
		});

		return data.map(x => new Video(x));
	},

	async setCues(video) {
		let { data } = await oldApi.post('Video.SetCues', {
			id: video.Id,
			opEnd: video.Data.cues.opEnd.position,
			edStart: video.Data.cues.edStart.position
		});

		return data;
	},

	async addView(id) {
		let { data } = await oldApi.post('Video.AddView', {
			id
		});

		return data;
	},

	async addComment(id, text, parent=0) {
		let { data } = await oldApi.post('Video.AddComment', {
			id,
			text,
			parent
		});

		return data;
	},

	async removeComment(commentId) {
		let { data } = await oldApi.post('Video.RemoveComment', {
			commentId
		});

		return data;
	},

	async markCommentAsSpoiler(commentId) {
		let { data } = await oldApi.post('Video.MarkCommentAsSpoiler', {
			commentId
		});

		return data;
	},

	hasBeenViewedBatch: new BatchRequest({
		async requestFunction(ids) {
			const {data} = await oldApi.get('Video.HasBeenWatched', {
				params: {
					ids
				}
			});

			return data;
		}
	}),

	async hasBeenViewed(id) {
		return this.hasBeenViewedBatch.fetch(id);
	}
};

oldApi.Series = {
	async list() {
		let {data} = await oldApi.get('Series.ListBy');

		return data.map(x => new Series(x));
	},
	async get(id) {
		let {data} = await oldApi.get('Series.Get', {
			params: {
				id
			}
		});

		return data ? new Series(data) : null;
	},
};

oldApi.Category = {
	async listBySeries(seriesId) {
		let {data} = await oldApi.get('Category.ListBy', {
			params: {
				seriesId
			}
		});

		return data.map(x => new Category(x));
	}
};


oldApi.Soundtracks = {
	async list() {
		let {data} = await oldApi.get('Soundtracks.ListBy');

		return data.map(x => new Soundtrack(x));
	}
};


Vue.prototype.$oldApi = oldApi;